import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from '../Assets/logo.png';
import {
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Button,
  Typography,
  TextField,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import excludeVariablesFromRoot from "@mui/material/styles/excludeVariablesFromRoot";
const steps = ["Enter Amount", "Enter Personal Details"]; 




const Home = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [stepOneInput, setStepOneInput] = useState("");
  const [errorStepOne, setErrorStepOne] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    mobile: "+91", // Initialize mobile with +91
    housename: "",
    place: "",
    post: "",
    pincode: "",
    district: "",
    state: "",
  });
  const [errorStepTwo, setErrorStepTwo] = useState(false);

  const handleNext = () => {
    if (activeStep === 0 && !stepOneInput) {
      setErrorStepOne(true);
      return;
    }
    if (activeStep === 1 && !validateStepTwo()) {
      setErrorStepTwo(true);
      return;
    }
    setErrorStepOne(false);
    setErrorStepTwo(false);
    setActiveStep((prev) => prev + 1);
  };

  const handleBack = () => setActiveStep((prev) => prev - 1);
  const handleReset = () => {
    setActiveStep(0);
    setStepOneInput("");
    setFormData({ 
      name: "",
      mobile: "+91", 
      housename: "",
      place: "",
      post: "",
      pincode: "",
      district: "",
      state: "",
    });
    setErrorStepOne(false);
    setErrorStepTwo(false);
  };

  const validateStepTwo = () => {
    const { name, mobile, housename, place, post, pincode, district, state } = formData;
    return (
      name && mobile && housename && place && post && pincode && district && state
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!stepOneInput) {
      alert("Please enter an amount.");
      setLoading(false);
      return;
    }

    try {
      const response = await fetch("https://api.sirajulhuda.com/api/v1/gateway-integration/orphan-care-public-donation/rzr-payment", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer test",
        },
        body: JSON.stringify({
          phone: formData.mobile,
          amount: stepOneInput,
          name: formData.name,
          house: formData.housename,
          place: formData.place,
          post: formData.postoffice,
          pincode: formData.pincode,
          district: formData.district,
          state: formData.state,
   
        }),
      });

      const res = await response.json();
      const orderData = res["data"];

      const options = {
        key: orderData["razorpay_key"],
        amount: orderData["fee"],
        currency: "INR",
        name: orderData["name"],
        description: "Donation",
        order_id: orderData["id"],
        handler: function (response) {
          navigate("/success", {
            state: {
              amount: stepOneInput,
              name: formData.name,
              orderId: response.razorpay_order_id // Add the order_id from Razorpay response
            }
          });
        },
        prefill: {
          name: orderData["name"],
          contact: orderData["phone"],
          email: "",
        },
        theme: {
          color: "#3399cc",
        },
        modal: {
          ondismiss: function () {
            console.log("Payment cancelled by user.");
            navigate("/failed");
          },
        },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (error) {
      console.error("Error during payment:", error);
      alert("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-home">
      <div className="container-donation">
        <img src={logo} className="logo-main" alt="" />
        <h2 className="donation-orphn-txt">Sirajul Huda Orphan Care Donation</h2>
        <Stepper activeStep={activeStep} orientation="vertical">
          {steps.map((label, index) => (
            <Step key={index}>
              <StepLabel >{label}</StepLabel>
              <StepContent >
                {index === 0 && (
                  <div>
                    <Typography>Enter amount:</Typography>
                    <TextField
                      fullWidth
                      variant="outlined"
                      type="number"
                      value={stepOneInput}
                      onChange={(e) => setStepOneInput(e.target.value)}
                      error={errorStepOne}
                      helperText={errorStepOne ? "This field is required" : ""}
                      style={{ marginTop: "10px" }}
                    />
                  </div>
                )}
                {index === 1 && (
                  <div>
                    <Typography>Enter your details:</Typography>
                    {[ "Name", "Mobile Number", "House Name", "Place", "Post Office", "Pincode", "District", "State"].map((label, i) => (
                      <TextField
                        fullWidth
                        key={i}
                        variant="outlined"
                        label={label}   
                        required
                        value={
                          label === "Mobile Number"
                            ? formData.mobile // Display the mobile number as is (including any country code)
                            : formData[label.toLowerCase().replace(/\s/g, "")]
                        }
                        onChange={(e) => {
                          const value = e.target.value;
                          if (label === "Mobile Number") {
                            // Allow any input for mobile number (including country code changes)
                            setFormData({
                              ...formData,
                              mobile: value,
                            });
                          } else {
                            setFormData({
                              ...formData,
                              [label.toLowerCase().replace(/\s/g, "")]: value,
                            });
                          }
                        }}
                        error={errorStepTwo && !formData[label.toLowerCase().replace(/\s/g, "")]}
                        helperText={
                          errorStepTwo && !formData[label.toLowerCase().replace(/\s/g, "")]
                            ? `${label} is required`
                            : ""
                        }
                        style={{ marginTop: "10px" }}
                        type={
                          label.toLowerCase() === "mobile number"
                            ? "tel"
                            : label.toLowerCase() === "pincode"
                              ? "number"
                              : "text"
                        }
                        inputProps={{
                          required: true,
                          ...(label === "Mobile Number" && {
                            // Allow any country code, not just +91
                            pattern: "^\\+[0-9]{1,3}[0-9]{6,14}$", // General pattern for international numbers
                            maxLength: 15 // Adjust max length to accommodate longer country codes
                          }),
                          ...(label === "Pincode" && {
                            pattern: "[0-9]{6}",
                            maxLength: 6
                          })
                        }}
                      />
                    ))}
                  </div>
                )}
                <div style={{ marginTop: "10px" }}>
                  <Button
                    className="btn-color"
                    variant="contained"
                    onClick={activeStep === steps.length - 1 ? handleSubmit : handleNext}
                    disabled={loading}
                  >
                    {loading ? (
                      <CircularProgress size={24} style={{ color: "white" }} />
                    ) : activeStep === steps.length - 1 ? (
                      "Pay"
                    ) : (
                      "Next"
                    )}
                  </Button>
                </div>
              </  StepContent>
            </Step>
          ))}
        </Stepper>
        {activeStep === steps.length && (
          <div style={{ marginTop: "20px" }}>
            <Typography>All steps completed</Typography>
            <Button onClick={handleReset} style={{ marginTop: "10px" }}>
              Reset
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Home;